export const clearCreateFlowLocalStorage = () => {
  localStorage.removeItem("data");
  localStorage.removeItem("crm");
  localStorage.removeItem("step");
};
